import Box from '@/common/components/Box';
import { options as unityForQuantityOptions } from '@/common/constants/unitForQuantityOptions.contant';
import { Trash } from 'lucide-react';
import { Controller, FieldArray, useFormContext } from 'react-hook-form';
import { ConsumptionValidationSchema } from '../schemas/create.schema';
import { CurrencyTextField } from '@/common/components/CurrencyTextField';
import { UnitTextField } from '@/common/components/UnitTextField';

interface ProductItemProps {
  index: number;
  field: FieldArray<ConsumptionValidationSchema, 'line_items_attributes'>;
  updateTotalValues: () => void;
  onDelete: () => void;
}

const ProductItem = ({ index, field, updateTotalValues, onDelete }: ProductItemProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<ConsumptionValidationSchema>();

  return (
    <Box className="flex flex-col gap-4 p-5 sm:p-6">
      <div className="flex items-center justify-between">
        <p className="text-base sm:text-[18px]">{field?.display_name}</p>

        <Trash strokeWidth={1} className="cursor-pointer" color="var(--warning)" onClick={() => onDelete()} />
      </div>

      <div className="flex gap-2 sm:gap-6">
        <div className="grow">
          <Controller
            name={`line_items_attributes.${index}.quantity`}
            control={control}
            render={({ field: inputField }) => (
              <UnitTextField
                unit={
                  field.unit_for_quantity
                    ? unityForQuantityOptions.find((option) => option.value === field.unit_for_quantity)?.symbol || ''
                    : ''
                }
                label="Quantidade"
                errorMessage={errors?.line_items_attributes?.[index]?.quantity?.message}
                {...inputField}
                onChange={(event) => {
                  inputField.onChange(event);
                  updateTotalValues();
                }}
                inputMode="numeric"
                markAsRequired
              />
            )}
          />
        </div>

        <div className="grow">
          <Controller
            name={`line_items_attributes.${index}.unitary_amount`}
            control={control}
            render={({ field, formState }) => (
              <CurrencyTextField
                label="Valor unit."
                {...field}
                errorMessage={formState.errors?.line_items_attributes?.[index]?.unitary_amount?.message}
                onChange={(event) => {
                  field.onChange(event);
                  updateTotalValues();
                }}
                inputMode="numeric"
                markAsRequired
              />
            )}
          />
        </div>
      </div>
    </Box>
  );
};

export default ProductItem;
